import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';

// La caché de lo que viene del servidor (sección 4.3 del estándar).
//
// El cliente se crea **una sola vez, fuera del componente**. Creado adentro, cada
// dibujado haría uno nuevo y la caché se vaciaría sola: el síntoma es una
// aplicación que vuelve a pedir todo cada vez que algo cambia en pantalla, y es
// difícil de ver porque *funciona*, solo que lento.
//
// Se exporta para quien no es un componente: el middleware que se entera de que
// suspendieron el taller (`permisos/suspension.ts`) invalida desde una petición.
export const cacheDatos = new QueryClient({
  defaultOptions: {
    queries: {
      // **Un reintento, no tres.**
      //
      // Los tres de fábrica están pensados para fallos de red. Acá la mayoría de
      // los fallos no lo son: un 401 con la sesión vencida, un 403 de permisos.
      // Reintentar eso tres veces retrasa el mensaje y pega tres veces contra el
      // servidor para recibir la misma negativa.
      retry: 1,

      // No se vuelve a pedir al volver a la pestaña.
      //
      // Es cómodo en una aplicación de escritorio y molesto acá: el
      // administrador del taller cambia de pestaña todo el tiempo, y cada vuelta
      // dispararía una ronda de consultas. Lo que de verdad tiene que estar
      // fresco se invalida cuando se escribe.
      refetchOnWindowFocus: false,
    },
  },
});

interface Props {
  children: ReactNode;
}

export function ProveedorDatos({ children }: Props) {
  return <QueryClientProvider client={cacheDatos}>{children}</QueryClientProvider>;
}
